export enum QueryParams {
  SORT = "sort",
  SEARCH = "search",
  IS_ACTIVE = "is-active",
  PAGE = "page",
  ITEMS_PER_PAGE = "items-per-page",
  PRICE_CHART_FILTER = "price-chart-filter",
}
